import { benTypes } from '../../../src/config';

let internationalPayees = [
	{
		id: '20037855-f07c-4298-80c6-9f5a9a5e966f',
		account: { id: '60aa2c51-52c3-4d36-aff8-7893c9a76c50', sort_code: '829279', account_number: '66677788' },
		to_account: {
			name: 'John',
			account_number: '49893829',
			bic: '',
			clearing_code: '',
		},
		display_name: 'INTERNATINAL Account Numbern PAYEE',
		reference: 'qweqwe',
		reference_high_value: '',
		address: {
			address_line_1: '1/1 somestreet',
			address_line_2: '',
			city: 'Glasgow',
			postal_code: 'G11 1CB',
			country: 'GB',
		},
		bank: {
			name: '',
			address: {
				address_line_1: '',
				address_line_2: '',
				city: 'Glasgow',
				postal_code: 'G11 1CB',
				country: 'DK',
			},
		},
		default_currency: 'CNY',
		type: 'international',
	},
	{
		id: '232320037855-f07c-4298-80c6-9f5a9a5e966f',
		account: { id: '60aa2c51-52c3-4d36-aff8-7893c9a76c50', sort_code: '829279', account_number: '66677788' },
		to_account: {
			name: 'John',
			iban: '34545345734878949893829',
			bic: '',
			clearing_code: '',
		},
		display_name: 'INTERNATINAL IBan PAYEE',
		reference: '@@@@@',
		reference_high_value: '',
		address: {
			address_line_1: '1/1 somestreet',
			address_line_2: '',
			city: 'Glasgow',
			postal_code: 'G11 1CB',
			country: 'GB',
		},
		bank: {
			name: '',
			address: {
				address_line_1: '',
				address_line_2: '',
				city: 'Glasgow',
				postal_code: 'G11 1CB',
				country: 'IN',
			},
		},
		default_currency: 'EUR',
		type: 'international',
	},
	{
		id: '95cf6ba8-7566-4943-a5e8-f67c16ab9bc9',
		account: {
			id: 'fbfbf663-3813-4639-a912-308b9060f975',
			sort_code: '823000',
			account_number: '10018229',
		},
		to_account: {
			account_number: '1234567890123456',
			name: 'USD',
			bic: 'CITIUS31',
		},
		reference: '',
		display_name: 'USD New payee',
		reference_high_value: 'USD',
		address: {
			city: 'USD',
			country: 'US',
			address_line_1: 'USD',
			address_line_2: '',
			postal_code: '',
		},
		bank: {
			address: {
				city: '',
				country: 'US',
				address_line_1: '',
				address_line_2: '',
				postal_code: '',
			},
			name: '',
		},
		default_currency: 'USD',
		type: 'international',
	},
];

const chapsPayees = [
	{
		id: '20037855-f07c-4298-80c6-9f5a9a5e966b',
		account: { id: '60aa2c51-52c3-4d36-aff8-1323c9a76c50', sort_code: '839275', account_number: '62623482' },
		to_account: { name: 'SIMON DAY Dupe', sort_code: '503939', account_number: '49893829' },
		display_name: 'SIMON DAY dupe',
		reference: 'qweqwe',
		reference_high_value: '',
		address: {
			address_line_1: '',
			address_line_2: '',
			city: 'Glasgow',
			postal_code: 'G11 1CB',
			country: '',
		},
		type: 'chaps',
	},
	{
		id: '20037855-f07c-4298-80c6-9f5a9a5e966a',
		account: { id: '60aa2c51-52c3-4d36-aff8-1323c9a76c50', sort_code: '839275', account_number: '62623482' },
		to_account: { name: 'SIMON DAY', sort_code: '503939', account_number: '49893829' },
		display_name: 'SIMONDAY',
		reference: 'qweqwe',
		reference_high_value: '',
		address: {
			address_line_1: '',
			address_line_2: '',
			city: 'Glasgow',
			postal_code: 'G11 1CB',
			country: '',
		},
		type: 'chaps',
	},
	{
		id: '30037855-f07c-4298-80c6-9f5a9a33986g',
		account: { id: '70aa2c51-52c3-4d36-aff8-1323c9a76c59', sort_code: '123456', account_number: '62623482' },
		to_account: { name: 'SIMON NIGHT', sort_code: '504949', account_number: '49999929' },
		display_name: 'SIMO_NIGHT12345678901234567890123456789012345678901234567890',
		reference: 'something',
		reference_high_value: '',
		address: {
			address_line_1: 'something_*lksdjhf',
			address_line_2: '',
			city: 'London',
			postal_code: 'L11 1CB',
			country: '',
		},
		type: 'chaps',
	},
];

const domesticPayees = [
	{
		// Previous cop check performed, has all required cop details
		id: '9d9cdd54-24de-45ff-a4cc-88831b44e719',
		account: { id: '0e4951cf-5134-42d1-8e46-4e52f21d053f', sort_code: '826817', account_number: '50017756' },
		reference: 'jkhklj',
		to_account: { name: 'easdsdf', sort_code: '898967', account_number: '89896700' },
		display_name: 'afsds',
		cop_account_name: 'Steve Smith', // This is the up to 140 character name entered by the customer.
		cop_account_type: 'Business', // This is Personal or Business, depending on the account type selected by the customer.
		confirmation_of_payee: {
			cop_status: 'active', //This will be either 'active' or 'inactive' where UI need to force CoP check in case found 'inactive'
			cop_reason_code: 'ANNM', // This will be the Pay.UK reason code
			cop_matching_outcome: true,
			matching_outcome: 'test',
		},
		type: 'chaps',
		reference_high_value:
			'££chapsreference9d9cdd5424de45ffa4cc88831b44e7199d9cdd5424de45ffa4cc88831b44e7199d9cdd5424de45ffa4cc88831b44e719',
		address: {
			address_line_1: 'address line 1',
			address_line_2: 'address line 2',
			city: 'city',
			postal_code: 'postal code',
		},
	},
	{
		// Previous cop check not performed, has all required cop details
		id: '9d9cdd54-24de-45ff-a4cc-88831b44e716',
		account: { id: '0e4951cf-5134-42d1-8e46-4e52f21d053f', sort_code: '826817', account_number: '50017756' },
		reference: 'jkhklj',
		reference_high_value: '£$% REFERENCE',
		to_account: { name: 'eaf', sort_code: '898967', account_number: '89896700' },
		singleUse: true,
		display_name: 'JohnSmith',
		cop_account_name: 'John Smith', // This is the up to 140 character name entered by the customer.
		cop_account_type: 'Business', // This is Personal or Business, depending on the account type selected by the customer.
		confirmation_of_payee: {
			cop_status: 'inactive', //This will be either 'active' or 'inactive' where UI need to force CoP check in case found 'inactive'
			cop_reason_code: 'ANNM', // This will be the Pay.UK reason code
		},
	},
	{
		// Previous cop check not performed, does not have all required cop details
		id: '08f4f2d1-39d7-42d5-b1b4-148baf413f89',
		account: { id: '0e4951cf-5134-42d1-8e46-4e52f21d053f', sort_code: '826817', account_number: '50017756' },
		reference: 'akriti%^&^$',
		to_account: { name: 'NeethuYBAccount', sort_code: '898967', account_number: '89896700' },
		display_name: 'AkritiYBNeethu',
		cop_account_type: 'Business',
		confirmation_of_payee: {
			cop_status: 'inactive', //This will be either 'active' or 'inactive' where UI need to force CoP check in case found 'inactive'
			cop_reason_code: 'ANNM', // This will be the Pay.UK reason code
		},
	},
	{
		// Previous cop check not performed, does not have all required cop details
		id: '08f4f2d1-39d7-42d5-b1b4-148baf413f8a',
		account: { id: '0e4951cf-5134-42d1-8e46-4e52f21d053f', sort_code: '826817', account_number: '50017756' },
		reference: 'Payee138',
		to_account: {
			name: '11111111112222222222333333333344444444445555555555',
			sort_code: '898967',
			account_number: '89896700',
		},
		display_name: 'COP138',
		cop_account_name:
			'111111111122222222223333333333444444444455555555556666666666777777777788888888889999999999000000000011111111112222222222333333333344444444', // This is the 138 character name entered by the customer.
		cop_account_type: 'Business',
		confirmation_of_payee: {
			cop_status: 'inactive', //This will be either 'active' or 'inactive' where UI need to force CoP check in case found 'inactive'
			cop_reason_code: 'ANNM', // This will be the Pay.UK reason code
		},
	},
	{
		id: '6cb003fe-dad8-45f4-9151-cbb87b62ef75',
		account: { id: '0e4951cf-5134-42d1-8e46-4e52f21d053f', sort_code: '826817', account_number: '50017756' },
		reference: 'Fried Chicken',
		to_account: { name: 'Colonel Sanders', sort_code: '898967', account_number: '89896700' },
		display_name: 'Colonel Sanders',
	},
	{
		id: '6d48270e-1b3d-4256-ac6e-bbb946b5d7b1',
		account: { id: '0e4951cf-5134-42d1-8e46-4e52f21d053f', sort_code: '826817', account_number: '50017756' },
		reference: 'dasf',
		to_account: { name: 'kjkl', sort_code: '898967', account_number: '89896700' },
		display_name: 'dzfgx',
	},
	{
		id: 'd17e4879-688a-4936-86a0-4bd7bb185ec0',
		account: { id: '0e4951cf-5134-42d1-8e46-4e52f21d053f', sort_code: '826817', account_number: '50017756' },
		reference: 'eaf',
		to_account: { name: 'jh', sort_code: '898967', account_number: '89896700' },
		display_name: 'eaf',
	},
	{
		id: 'baf51182-1501-4145-b8fd-341ffc9cdf90',
		account: { id: '0e4951cf-5134-42d1-8e46-4e52f21d053f', sort_code: '826817', account_number: '50017756' },
		reference: 'efs',
		to_account: { name: 'esfdsefd', sort_code: '898967', account_number: '89896700' },
		display_name: 'esr',
	},
	{
		id: '9ed90f35-e292-48a8-a7db-b145a0792d13',
		account: { id: '0e4951cf-5134-42d1-8e46-4e52f21d053f', sort_code: '826817', account_number: '50017756' },
		reference: 'FGFHG',
		to_account: { name: 'hg', sort_code: '898967', account_number: '89896700' },
		display_name: 'gfh',
	},
	{
		id: 'ed652bef-dc36-4f89-ba90-e35947af6608',
		account: { id: '0e4951cf-5134-42d1-8e46-4e52f21d053f', sort_code: '826817', account_number: '50017756' },
		reference: 'jhknmb',
		to_account: { name: 'fghgkjm', sort_code: '898967', account_number: '89896700' },
		display_name: 'gfhmn',
	},
	{
		id: 'cc0cf512-ddf7-4072-88b9-bf6bb68c3421',
		account: { id: '0e4951cf-5134-42d1-8e46-4e52f21d053f', sort_code: '826817', account_number: '50017756' },
		reference: 'hgjh',
		to_account: { name: 'gjh', sort_code: '898967', account_number: '89896700' },
		display_name: 'hjg',
	},
	{
		id: '4b01e4fd-6ea9-4b27-b5e9-c87221964746',
		account: { id: '0e4951cf-5134-42d1-8e46-4e52f21d053f', sort_code: '826817', account_number: '50017756' },
		reference: 'kjyj',
		to_account: { name: '576', sort_code: '898967', account_number: '89896700' },
		display_name: 'hkjh',
	},
	{
		id: '8e348215-58d0-45fe-8bcb-398b15a58050',
		account: { id: '0e4951cf-5134-42d1-8e46-4e52f21d053f', sort_code: '826817', account_number: '50017756' },
		reference: 'fghf',
		to_account: { name: '8uy', sort_code: '898967', account_number: '89896700' },
		display_name: 'jgk',
	},
	{
		id: '0c1a6113-5e44-4d20-b454-33e720aed4d6',
		account: { id: '0e4951cf-5134-42d1-8e46-4e52f21d053f', sort_code: '826817', account_number: '50017756' },
		reference: 'jj',
		to_account: { name: 'hlkh', sort_code: '898967', account_number: '89896700' },
		display_name: 'jkh',
	},
	{
		id: '71a0fd56-3aef-47e2-8773-fadd491fdac7',
		account: { id: '0e4951cf-5134-42d1-8e46-4e52f21d053f', sort_code: '826817', account_number: '50017756' },
		reference: 'hgjh',
		to_account: { name: 'gj', sort_code: '898967', account_number: '89896700' },
		display_name: 'jlkh',
	},
	{
		id: '2345b975-1a10-4370-b238-b7a36fc72586',
		account: { id: '0e4951cf-5134-42d1-8e46-4e52f21d053f', sort_code: '826817', account_number: '50017756' },
		reference: 'kjhj',
		to_account: { name: 'gfghf', sort_code: '898967', account_number: '89896700' },
		display_name: 'kljkl',
	},
	{
		id: 'fd01f10b-1909-491f-944d-2c3d17cff150',
		account: { id: '0e4951cf-5134-42d1-8e46-4e52f21d053f', sort_code: '826817', account_number: '50017756' },
		reference: 'jhj',
		to_account: { name: 'hjjk', sort_code: '898967', account_number: '89896700' },
		display_name: 'mhkj',
	},
	{
		id: '8add59c1-3d4d-44e5-a03e-c4daa2919605',
		account: { id: '0e4951cf-5134-42d1-8e46-4e52f21d053f', sort_code: '826817', account_number: '50017756' },
		reference: 'ghgh',
		to_account: { name: 'jkh', sort_code: '898967', account_number: '89896700' },
		display_name: 'nmhj',
	},
	{
		id: 'c6f3ad9e-b67b-43b3-9b49-b3a7b7176367',
		account: { id: '0e4951cf-5134-42d1-8e46-4e52f21d053f', sort_code: '826817', account_number: '50017756' },
		reference: 'Breakfast',
		to_account: { name: 'Ronald McDonald', sort_code: '898967', account_number: '89896700' },
		display_name: 'Ronald McDonald',
	},
	{
		id: 'f46e12ba-7280-4303-a908-baf71e758391',
		account: { id: '0e4951cf-5134-42d1-8e46-4e52f21d053f', sort_code: '826817', account_number: '50017756' },
		reference: 'wE',
		to_account: { name: 'Test', sort_code: '898967', account_number: '89896700' },
		display_name: 'SHUBH',
	},
	{
		id: '61a0bef1-2c2a-4cc1-b52e-2fe9ea116b82',
		account: { id: '0e4951cf-5134-42d1-8e46-4e52f21d053f', sort_code: '826817', account_number: '50017756' },
		reference: 'OTP',
		to_account: { name: 'Shubh', sort_code: '898967', account_number: '89896700' },
		display_name: 'Shubh',
	},
];

let allPayees = [...domesticPayees, ...chapsPayees, ...internationalPayees];
let UKPayees = [...domesticPayees, ...chapsPayees];

export const deletePayee = (body, url) => {
	const payeeId = url.substr(url.lastIndexOf('/') + 1);
	internationalPayees = internationalPayees.filter((payee) => payee.id !== payeeId);
	UKPayees = UKPayees.filter((payee) => payee.id !== payeeId);
	allPayees = allPayees.filter((payee) => payee.id !== payeeId);
};

export const pagedPayees = (body, url) => {
	const searchParams = new URLSearchParams(url);
	const pageIndex = url.indexOf('page=');
	const page = Number(url.substring(pageIndex + 5, pageIndex + 6));
	const search = searchParams.get('search');
	const benType = searchParams.get('benType');
	const accountNumber = searchParams.get('accountNumber');
	const sortCode = searchParams.get('sortCode');
	const payeeName = searchParams.get('name');
	const links = {
		first: `/banks/CB/accounts/default/beneficiaries/paged?benType=${benType}&page=1&size=204`,
		last: `/banks/CB/accounts/default/beneficiaries/paged?benType=${benType}&page=${page + 1}&size=204`,
		next: `/banks/CB/accounts/default/beneficiaries/paged?benType=${benType}&page=${page + 1}&size=204`,
	};
	if (page === 2) {
		links.previous = `/banks/CB/accounts/default/beneficiaries/paged?benType=${benType}&page=${page - 1}&size=204`;
		delete links.next;
	}
	let beneficiaries = [];
	switch (benType) {
		case benTypes.IFT:
			beneficiaries = internationalPayees;
			break;
		case benTypes.UK:
			beneficiaries = UKPayees;
			break;
		default:
			beneficiaries = allPayees;
			break;
	}
	if (accountNumber && payeeName) {
		beneficiaries = beneficiaries.filter(
			({ to_account: { name, sort_code = '', account_number = '', iban = '' } }) =>
				payeeName === name &&
				[iban, account_number].includes(accountNumber) &&
				(sortCode ? sort_code === sortCode : true)
		);
	}
	return {
		beneficiaries,
		page_meta_data: {
			page_size: 204,
			page_number: page,
			total_pages: 2,
			total_elements: 300,
			search_text: search,
			ben_type: benType,
		},
		links,
	};
};

export default [...allPayees];
